import { Box, Checkbox, styled, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, Pagination, Stack, InputAdornment, } from "@mui/material";
import React, { useEffect, useState } from "react";
import { farmers, region, taskAssign } from "../../config/images";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { addMachineryEquipment, deleteMachineryEquipment, editMachineryEquipment, getTypeOfMachineryExcel, importTypeOfMachineryExcel, machinery, macineryBulkDelete, } from "../../config/services";
import { downloadFile } from "../../config/DownloadFile";
import translations from "../../config/language";
import AddMachineryPopup from "./Popup.js/AddMachineryPopup";
import EditMachineryPopup from "./Popup.js/EditMachineryPopup";
import DeleteMachineryPopup from "./Popup.js/DeleteMachineryPopup";
import ImportExcelPopup from "./Popup.js/ImportExcelPopup";
import { notifyError, notifySuccess } from "../../config/ToastMessage";
import { useSelector } from "react-redux";

const MachineryData = () => {
  const navigate = useNavigate();
  const [editMachinery, setEditMachinery] = useState(false);
  const [deleteMachinery, setDeleteMachinery] = useState(false);
  const [addMachinery, setAddMachinery] = useState(false);
  const [importExcel, setImportExcel] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [machineryData, setMachineryData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [addMachineryData, setAddMachineryData] = useState("");
  const [addSubCategoryData, setAddSubCategoryData] = useState("");
  const [editMachineryData, setEditMachineryData] = useState([""]);
  const [editSubCategoryData, setEditSubCategoryData] = useState("");
  const [editId, setEditId] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState();
  const [loading, setIsLoading] = useState(false);
  const [selectedmachineryTable, setSelectedMachineryTable] = useState([]);
  const [bulkDeleteLoading, setBulkDeleteLoading] = useState(false);
  const [importExcelLoading, setImportExcelLoading] = useState(false);

  const { module_access } = useSelector((state) => state.userState)
  const isAccess = module_access?.find((module) =>
    module.module_name === "Types of Machinery" && module.is_editor === true
  ) ? true : false;

  const handleChange = (event, value) => {
    setCurrentPage(value);
  };
  const location = useLocation();
  const param = useParams();
  const machineryName = location.state?.name;

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileType = file.name.split('.').pop().toLowerCase();
      if (fileType === 'xlsx' || fileType === 'xls') {
        setSelectedFile(file);
      } else {
        notifyError(translations[language].pleaseSelectExcelFile || 'Please select an Excel file');
        event.target.value = null; // Reset file input
      }
    }
  };

  useEffect(() => {
    handlegetmachineryData();
  }, [currentPage]);

  const handlegetmachineryData = async () => {
    try {
      const resp = await machinery(param.id, currentPage, perPage);
      if (resp.status == 200 || resp.status == 201) {
        setMachineryData(resp?.data?.results?.payload);
        setCount(resp.data.count);
      }
    } catch (error) {
      setMachineryData([]);
    }
  };
  const filteredMachinery = machineryData.filter((crop) =>
    crop.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleAddData = async (event, subCategories) => {
    event.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    const params = {
      machinery_equipment_subcategory: subCategories.map(subCategory => ({
        type_of_machinery_equipment: param.id,
        name: subCategory,
      })),
      name: addMachineryData,
      type_of_machinery: param.id,
    };
    try {
      setIsLoading(true);
      const resp = await addMachineryEquipment(params);
      if (resp.status == 200 || resp.status == 201) {
        notifySuccess(resp.data.message);
        setAddMachinery(false);
        handlegetmachineryData();
        setAddMachineryData("");
        setAddSubCategoryData("");
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    } catch (error) {
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
      notifyError(error.response.data.message);
      setAddMachinery(false);
      setAddMachineryData("");
      setAddSubCategoryData("");
    }
  };
  const handleCancel = (e) => {
    if (e) e.preventDefault(); // Prevents default behavior (useful for form buttons)
    setAddMachinery(false); // Closes the popup
    setEditMachinery(false);
    setAddMachineryData("");
    setAddSubCategoryData("");
    setDeleteMachinery(false);
  };
  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));

  const handleEditPopup = (e, sub_catergory) => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    setEditId(e.id);
    setEditMachinery(true);
    setEditMachineryData(e.name);
    setEditSubCategoryData(sub_catergory.map(item => item.name));
  };

  const handleEditMachinery = async (event) => {
    event.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    if (!editMachineryData) {
      notifyError("Enter Machinery");
      return;
    }

    const params = {
      machinery_equipment_subcategory: editSubCategoryData.map(subCategory => ({
        type_of_machinery_equipment: param.id,
        name: subCategory,
      })),
      name: editMachineryData,
      type_of_machinery: param.id,
    };
    try {
      setIsLoading(true);
      const resp = await editMachineryEquipment(params, editId);
      if (resp.status == 200 || resp.status == 201) {
        notifySuccess(resp.data.message);
        setEditMachinery(false);
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
        handlegetmachineryData();
      }
    } catch (error) {
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
      notifyError(error.response.data.message);
      setEditMachinery(false);
    }
  };

  const handleDeletePopup = (e) => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    setEditId(e.id);
    setDeleteMachinery(true);
  };

  const handleDeleteDta = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    try {
      setIsLoading(true);
      const resp = await deleteMachineryEquipment(editId);
      if (resp.status == 200 || resp.status == 201) {
        notifySuccess(resp.data.message);
        setDeleteMachinery(false);
        handlegetmachineryData();
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    } catch (error) {
      notifyError(error.response.data.message);
      setDeleteMachinery(false);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  };

  const handleRowSelect = (id) => {
    setSelectedMachineryTable((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id]
    );
  };

  // Function to handle "Select All"
  const handleSelectAll = () => {
    if (selectedmachineryTable.length === filteredMachinery.length) {
      setSelectedMachineryTable([]); // Uncheck all
    } else {
      setSelectedMachineryTable(filteredMachinery.map((e) => e.id)); // Select all
    }
  };

  const handleBulkDelete = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    setBulkDeleteLoading(true);

    const params = {
      ids: selectedmachineryTable
    }

    try {
      const resp = await macineryBulkDelete(params)


      if (resp.data.success) {
        notifySuccess(resp.data.message);

        handlegetmachineryData();
        setSelectedMachineryTable([]);

      }
      setTimeout(() => {
        setBulkDeleteLoading(false);
      }, 2000);


    } catch (error) {
      console.log(error);
      notifyError(error.response.data.message);
      setSelectedMachineryTable([]);
      setTimeout(() => {
        setBulkDeleteLoading(false);
      }, 2000);
    }
  }

  const language = process.env.REACT_APP_LANGUAGE;


  const handleDemoFile = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    const params = {
      machinery_type_id: Number(param.id)
    };
    try {
      const res = await getTypeOfMachineryExcel(params);
      if (res.data.success == true) {
        downloadFile(res);
        notifySuccess(translations[language].downloadSuccess);
      }
    } catch (error) {
      console.log("error", error);
      notifyError(error.response?.data?.message || translations[language].downloadFailed);
    }
  }

  const handleImportExcel = async (e) => {
    e.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    if (!selectedFile) {
      notifyError(translations[language].pleaseSelectFile);
      return;
    }
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("machinery_type_id", param.id);

    try {
      setImportExcelLoading(true);
      const resp = await importTypeOfMachineryExcel(formData);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        handlegetmachineryData();
        setImportExcel(false);
        setSelectedFile(null);
        setImportExcelLoading(false);
      }
    } catch (error) {
      console.log(error);
      notifyError(error.response.data.message);
      setImportExcel(false);
      setSelectedFile(null);
      setImportExcelLoading(false);
    }
  }
  return (
    <>
      <Box className="task-assign-box">
        <Box
          className="d-flex justify-content-between align-items-center"
          style={{ flexWrap: "wrap" }}
        >
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img
              src={taskAssign.backArrow}
              alt=""
              style={{ height: "44px", width: "44px", cursor: "pointer" }}
              onClick={() => navigate("/machinery")}
            />
            <img src={region.region} alt="" />
            <Typography variant="h6" gutterBottom>
              {machineryName}
            </Typography>
          </Box>
          <Box className="assign-data-btn">
            <img
              src={region.deleteIcon}
              alt=""
              style={{ cursor: bulkDeleteLoading ? "not-allowed" : "pointer", marginRight: "10px" }}
              disabled={bulkDeleteLoading}
              onClick={() => handleBulkDelete()}
              className="delete-btn"
            />
            <button className="deactivate-btn" style={{ marginRight: "10px" }} onClick={() => handleDemoFile()}>
              {translations[language].demoFile}
            </button>
            <button
              className="deactivate-btn"
              style={{ marginRight: "10px" }}
              onClick={() => {
                if (!isAccess) {
                  notifyError(translations[language].youDontHaveAccess);
                  return true;
                }setImportExcel(true)}
              }
            >
              {translations[language].importExcel}
            </button>
            <button
              className="assign-task-btn"
              style={{ marginLeft: "0px" }}
              onClick={() => {
                if (!isAccess) {
                  notifyError(translations[language].youDontHaveAccess);
                  return true;
                }
                setAddMachinery(true)}
              }
            >
              {translations[language].addMachinery}
            </button>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #31A05F",
            borderRadius: "4px",
            overflow: "hidden",
            margin: "0px 20px",
          }}
          className="mt-3 mb-4"
        >
          <TextField
            placeholder={translations[language].searchHere}
            variant="outlined"
            size="small"
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
                paddingRight: "0px",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  sx={{
                    color: "#FFFFFF",
                    fontWeight: "400",
                    backgroundColor: "#31A05F",
                    height: "100%",
                    padding: "0px",
                    maxHeight: "unset",
                    padding: "0px 15px",
                  }}
                >
                  <SearchIcon sx={{ color: "#FFFFFF", mr: 1 }} />
                  {translations[language].search}
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box className="crop-table-container">
          <Table className="region-table pt-1" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "50px" }}>
                  <Checkbox
                    sx={{
                      color: "rgba(225, 230, 244, 1)",
                      borderRadius: "4px",
                      "&.Mui-checked": {
                        color: "rgba(199, 206, 227,1)",
                      },
                    }}
                    checked={selectedmachineryTable.length === filteredMachinery.length}
                    onChange={handleSelectAll}
                  />
                </TableCell>
                <TableCell style={{ width: "100px" }}>{translations[language].srNo}</TableCell>
                <TableCell style={{ width: "200px" }}>
                  {machineryName} Name
                </TableCell>
                <TableCell>Sub - Category </TableCell>
                <TableCell style={{ width: "100px" }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredMachinery.length > 0 ? (
                filteredMachinery.map((machinery, index) => (
                  <TableRow key={machinery.id}>
                    <TableCell>
                      <Checkbox
                        sx={{
                          color: "rgba(225, 230, 244, 1)",
                          borderRadius: "4px",
                          "&.Mui-checked": {
                            color: "rgba(199, 206, 227,1)",
                          },
                        }}
                        checked={selectedmachineryTable.includes(machinery.id)}
                        onChange={() => handleRowSelect(machinery.id)}
                      />
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {index + 1 + (currentPage - 1) * perPage}
                    </TableCell>
                    <TableCell>{machinery.name}</TableCell>
                    <TableCell>
                      {machinery.machinery_equipment_subcategory
                        .map(sub => sub.name)
                        .join(", ")}
                    </TableCell>
                    <TableCell>
                      <div className="d-flex gap-3">
                        <img
                          src={region.editIcon}
                          alt="Edit"
                          onClick={() => handleEditPopup(machinery, machinery.machinery_equipment_subcategory || {})}
                          style={{ cursor: "pointer", height: "23px" }}
                        />
                        <img
                          src={region.deleteIcon}
                          alt="Delete"
                          onClick={() => handleDeletePopup(machinery)}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} style={{ textAlign: "center" }}>
                    <img src={farmers.noData} alt="No Data" />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
        <Box
          display="flex"
          justifyContent="end"
          alignItems="center"
          className="pagination"
        >
          <Stack spacing={2} className="mb-3">
            <CustomPagination
              count={Math.ceil(count / perPage)}
              page={currentPage}
              onChange={handleChange}
              color="primary"
            />
          </Stack>
        </Box>
        <AddMachineryPopup
          open={addMachinery}
          onClose={handleCancel}
          addMachineryData={addMachineryData}
          setAddMachineryData={setAddMachineryData}
          addSubCategoryData={addSubCategoryData}
          setAddSubCategoryData={setAddSubCategoryData}
          handleAddData={handleAddData}
          loading={loading}
          translations={translations}
          language={language}
        />
        <EditMachineryPopup
          open={editMachinery}
          onClose={handleCancel}
          editMachineryData={editMachineryData}
          setEditMachineryData={setEditMachineryData}
          editSubCategoryData={editSubCategoryData}
          setEditSubCategoryData={setEditSubCategoryData}
          handleEditMachinery={handleEditMachinery}
          loading={loading}
          translations={translations}
          language={language}
        />
        <DeleteMachineryPopup
          open={deleteMachinery}
          onClose={handleCancel}
          handleDelete={handleDeleteDta}
          loading={loading}
          translations={translations}
          language={language}
        />
        <ImportExcelPopup
          open={importExcel}
          onClose={() => setImportExcel(false)}
          selectedFile={selectedFile}
          handleFileChange={handleFileChange}
          handleImportExcel={handleImportExcel}
          loading={importExcelLoading}
          translations={translations}
          language={language}
        />
      </Box>
    </>
  );
};

export default MachineryData;